import type { ServicerQueueRow } from './servicer-queue-row.type.ts';

/**
 * Read-only projection of a `ServicerQueueRow` — the admin Servicer Match
 * queue's row, backed by `GET /api/v2/servicer-queue-rows`.
 *
 * The person and the upload are flat fields on the row, so the shared
 * provenance cells are fed by projecting them into the one-element lists those
 * cells render for the cross-person `resolution` queue.
 */
export interface ServicerQueueRowExtension extends ServicerQueueRow {}
export class ServicerQueueRowExtension {
  get isPending() {
    return this.status === 'pending';
  }

  get isResolvedByUser() {
    return this.status === 'resolved_by_user';
  }

  get isResolvedByTio() {
    return this.status === 'resolved_by_tio';
  }

  /** Whether the member's own pick exists — the switch for offering it back as the answer. */
  get hasUserSelection() {
    return this.selectedServicer != null;
  }

  /** The row's owner, shaped as the one-element list the shared people cell renders. */
  get provenancePeople() {
    if (!this.personId) return [];
    return [{ id: this.personId, name: this.personName ?? null }];
  }

  /** Always 0 — a row carries its whole owner, not a sample. */
  get hiddenPeopleCount() {
    return 0;
  }

  /** The row's upload, shaped as the one-element list the shared documents cell renders. */
  get provenanceSourceDocuments() {
    if (!this.documentId) return [];
    return [
      {
        id: this.documentId,
        provider: this.documentProvider,
        provided_at: this.documentUploadedAt ?? null,
        person_id: this.personId,
      },
    ];
  }

  /** Always 0 — a row carries its whole upload, not a sample. */
  get hiddenSourceDocumentsCount() {
    return 0;
  }
}

const Registration = {
  kind: 'object',
  name: 'servicer-queue-row',
  features: ServicerQueueRowExtension,
};
export default Registration;
